var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ready)?_c('Row',{class:_vm.classes()},[_c('Column',{attrs:{"width":_vm.left}}),_c('Column',{staticStyle:{"padding-left":"5px"},attrs:{"width":_vm.middle}},[_vm._t("default")],2),_c('Column',{attrs:{"width":_vm.right}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }